import React, { Fragment } from 'react';
import CategoryAndFolderSelector from './CategoryAndFolderSelector';
import { getExternalSitesUrl } from '../../utilities/urlHelper';

class MoveSubcategoryModal extends React.Component {
    onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            this.closeModal();
        }
    };

    closeModal = () => {
        if (this.props.closeModal) {
            this.props.closeModal();
        }
    };

    render() {
        const { subcategory } = this.props;
        const objectType = subcategory.category_id ? 'subcategory' : 'category';
        const descriptionText = `Move ${objectType} and contained items`;
        const updateUrl = `/teams/${window.teamDomain}/${subcategory.category_id ? 'sub' : ''}categories/${subcategory.id}`;
        const hasExternalSites = objectType === 'category' && (subcategory.has_external_sites === true || subcategory?.external_sites?.length > 0);

        return (
            <div className="react-modal open move-folder-modal" onMouseDown={this.onClickModal}>
                <div className="modal-content">
                    <h2>
                        {`Move ${objectType}`}
                    </h2>
                    <div className="mt2 mb2 flex">
                        <img className="flex-none mr1 rounded" height="28" src={subcategory.icon} style={{ backgroundColor: `#${subcategory.color}` }} alt="folder icon" />
                        <div className="flex-auto">
                            <span className="h4">{subcategory.name || subcategory.title}</span>
                        </div>
                    </div>
                    { hasExternalSites
                        ? (
                            <Fragment>
                                <div className="mt2 flex bold red">
                                    Cannot move this category as it's an
                                    &nbsp;
                                    <a href={getExternalSitesUrl()}>external site</a>
                                    .
                                </div>

                                <div className="right-align mt2">
                                    <span className="react-modal-close btn-secondary mr1" onClick={this.closeModal}>Close</span>
                                </div>
                            </Fragment>
                        )
                        : (
                            <Fragment>
                                <div className="mt2 flex italic">
                                    {descriptionText}
                                </div>

                                <form action={updateUrl} method="POST">
                                    <input name="_token" type="hidden" value={window.csrfToken} />
                                    <input name="_method" type="hidden" value="put" />
                                    <input name="move" type="hidden" value="true" />
                                    <div className="mt2 mb2">
                                        {subcategory.category_id
                                            ? (
                                                <CategoryAndFolderSelector
                                                    initialCategoryId={subcategory.category_id}
                                                    initialFolderId={subcategory.folder_id}
                                                    excludeFolder={subcategory.id}
                                                    uncategorizePlaceholder="Move to root level"
                                                />
                                            )
                                            : (
                                                <CategoryAndFolderSelector
                                                    excludeCategory={subcategory.id}
                                                    allowUncategorize={false}
                                                    uncategorizePlaceholder="Root level"
                                                />
                                            )}

                                    </div>
                                    <div className="right-align">
                                        <span className="react-modal-close btn-secondary mr1" onClick={this.closeModal}>Close</span>
                                        <input type="submit" className="btn btn-primary" value={`Move ${objectType}`} />
                                    </div>
                                </form>
                            </Fragment>
                        )}
                </div>
            </div>
        );
    }
}

export default MoveSubcategoryModal;
